module.exports = __webpack_public_path__ + "static/media/SummonAery.393112b7.png";